import React from 'react'
import { useInput } from 'react-admin'
import SunEditor from 'suneditor-react'
import addButtonPlugin from './AddButtonPlugin'
import plugins from 'suneditor/src/plugins'
import { landingServices } from 'src/services/reservation/landing/Landing.service'
import customLinkPlugin from './CustomLinkPlugin'

export const HTMLInputLanding = ({ source, validate, ...props }) => {
  const { field } = useInput({
    source,
    validate,
    defaultValue: props.defaultValue
  })

  const sortedFontOptions = [
    'Arial',
    'Comic Sans MS',
    'Courier New',
    'Impact',
    'Geneva',
    'Georgia',
    'Tahoma',
    'Trebuchet MS',
    'Verdana',
    'Logical',
    'Montserrat',
    'Salesforce Sans',
    'Garamond',
    'Sans-Serif',
    'Serif',
    'Times New Roman',
    'Helvetica'
  ].sort();

  const handleChange = (content) => {
    field.onChange(content)
    props.onChange && props.onChange(content)
  }

  const onUploadImage = (files, info, uploadHandler) => {
    const formData = new FormData()
    formData.append('image_url', files[0])

    landingServices.uploadImages(formData)
      .then(response => {
        const data = {
         result: [
           {
            url: response?.image_url?.src,
            name: files[0].name,
            size: files[0].size
          },
     ]}
        uploadHandler(data)
      })

    return false
  }

  const applyDefaultMargins = (instance) => {
    if (!field.value) {
      const editorContent = instance?.core?.context?.element?.wysiwyg;
      const paragraphs = editorContent?.querySelectorAll('p');
      const lastParagraph = paragraphs?.[paragraphs.length - 1];
      if (lastParagraph && !lastParagraph.style.marginLeft) {
        lastParagraph.style.marginLeft = '50px';
      }
    }
  }

  return (
    <SunEditor
      lang='es'
      getSunEditorInstance={applyDefaultMargins}
      defaultValue={field.value}
      onChange={handleChange}
      onImageUploadBefore={onUploadImage}
      setOptions={{
        plugins: {
          ...plugins,
          customLink: customLinkPlugin,
          addButton: addButtonPlugin
        },
        defaultStyle: 'font-family: Montserrat; font-size: 16px',
        lineHeights: [
          {text: '1.0', value: 1},
          {text: '1.15', value: 1.15},
          {text: '2.0', value: 2},
          {text: '2.5', value: 2.5},
          {text: '3.0', value: 3}
        ],
        buttonList: [
          ['undo', 'redo'],
          ['font', 'fontSize', 'formatBlock'],
          ['paragraphStyle', 'blockquote'],
          [
            'bold',
            'underline',
            'italic',
            'strike',
            'subscript',
            'superscript',
          ],
          ['fontColor', 'hiliteColor', 'textStyle'],
          ['align', 'list', 'lineHeight'],
          ['outdent', 'indent'],
          ['removeFormat'],
          [
            '-right',
            'table',
            'horizontalRule',
            {
                name: 'customLink', 
                dataDisplay: 'dialog',
                title: 'Link', 
                innerHTML: '<svg viewBox="0 0 24 24"><path d="M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z" /></svg>'
            },
            {
              name: 'addButton',
              dataDisplay: 'dialog',
              title: 'Botón personalizado',
              innerHTML:
                `<svg xmlns='http://www.w3.org/2000/svg' enable-background='new 0 0 24 24' height='24px' viewBox='0 0 24 24' width='24px' fill='#e8eaed'><path d='M11.71,17.99C8.53,17.84,6,15.22,6,12c0-3.31,2.69-6,6-6c3.22,0,5.84,2.53,5.99,5.71l-2.1-0.63C15.48,9.31,13.89,8,12,8 c-2.21,0-4,1.79-4,4c0,1.89,1.31,3.48,3.08,3.89L11.71,17.99z M22,12c0,0.3-0.01,0.6-0.04,0.9l-1.97-0.59C20,12.21,20,12.1,20,12 c0-4.42-3.58-8-8-8s-8,3.58-8,8s3.58,8,8,8c0.1,0,0.21,0,0.31-0.01l0.59,1.97C12.6,21.99,12.3,22,12,22C6.48,22,2,17.52,2,12 C2,6.48,6.48,2,12,2S22,6.48,22,12z M18.23,16.26L22,15l-10-3l3,10l1.26-3.77l4.27,4.27l1.98-1.98L18.23,16.26z'/></svg>`,
            },
            'image',
            'video'
          ]
        ],
        minHeight: '400px',
        showPathLabel: false,
        font: sortedFontOptions,
        addTagsWhitelist: 'button',
        attributesWhitelist: { all: 'style' }
      }}
    />
  )
}
